import { render, staticRenderFns } from "./PreplanningClients.vue?vue&type=template&id=45c65c49&scoped=true&"
import script from "./PreplanningClients.vue?vue&type=script&lang=js&"
export * from "./PreplanningClients.vue?vue&type=script&lang=js&"
import style0 from "./PreplanningClients.vue?vue&type=style&index=0&id=45c65c49&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c65c49",
  null
  
)

export default component.exports